import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

// Sayyor sud: rejalashtirish, o'tkazilganlar va suratli dalil.
//
// Suratlar 2026-09-27 dan serverda saqlanadi (038-migratsiya izohi):
// modulning vazifasi hisobot emas, soxtalikning oldini olish. Shu sahifa
// har bir suratni olingan vaqti, joylashuvi va ogohlantirish belgilari
// bilan ko'rsatadi — inspektor o'sha yerda bo'lganini shu isbotlaydi.

// Suratni <img src> bilan ochib bo'lmaydi: u token talab qiladi, <img>
// esa sarlavha yubormaydi. Shuning uchun axios bilan yuklab, brauzer
// xotirasidagi havolaga aylantiramiz.
function SuratOyna({ foto, token, yop }) {
  const [manba, setManba] = useState(null);
  const [xato, setXato] = useState('');

  useEffect(() => {
    let obj;
    axios.get(`${API}${foto.url}`, { headers: { authorization: token }, responseType: 'blob' })
      .then((r) => { obj = URL.createObjectURL(r.data); setManba(obj); })
      .catch(() => setXato(tr("Rasmni ochib bo'lmadi")));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [foto.url, token]);

  return (
    <div onClick={yop} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 50,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px'
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        background: '#fff', borderRadius: '12px', padding: '16px',
        maxWidth: '760px', width: '100%', maxHeight: '90vh', overflow: 'auto'
      }}>
        {xato && <div style={{ color: '#d32f2f', fontSize: '13px' }}>{xato}</div>}
        {!manba && !xato && <div style={{ color: '#888' }}>{tr("Yuklanmoqda…")}</div>}
        {manba && <img src={manba} alt={tr("Sayyor sud surati")} style={{ width: '100%', borderRadius: '10px' }} />}
        <div style={{ fontSize: '12px', color: '#666', marginTop: '10px', lineHeight: 1.6 }}>
          {foto.olingan_vaqt
            ? tr("Olingan vaqti: {vaqt}", { vaqt: new Date(foto.olingan_vaqt).toLocaleString() })
            : tr("Olingan vaqti qayd etilmagan")}
          <br />
          {foto.latitude != null
            ? tr("Joylashuvi: {lat}, {lon}", { lat: Number(foto.latitude).toFixed(6), lon: Number(foto.longitude).toFixed(6) })
            : tr("Joylashuv qayd etilmagan")}
          <br />
          {tr("Fayl izi (SHA-256): {xesh}", { xesh: foto.sha256 })}
        </div>
        <button onClick={yop} style={{ ...smallBtn, marginTop: '12px' }}>{tr("Yopish")}</button>
      </div>
    </div>
  );
}

// Suratlar ro'yxati: har birida vaqt, masofa va ogohlantirish belgisi.
function Suratlar({ fotolar, token }) {
  const [ochiq, setOchiq] = useState(null);
  if (!fotolar || fotolar.length === 0) {
    return (
      <div style={{ fontSize: '13px', color: '#888', marginBottom: '12px' }}>
        {tr("Surat yuborilmagan — bu sud dalilsiz qolgan.")}
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '14px' }}>
      <p style={{ fontSize: '12px', color: '#888', margin: '0 0 8px' }}>
        {tr("Suratlar ({soni} ta) — olingan zahoti serverga yuborilgan", { soni: fotolar.length })}
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
        {fotolar.map((f, i) => {
          const ogoh = f.soxta_gps || f.latitude == null || !f.olingan_vaqt
            || (f.masofa_m != null && f.masofa_m > 500);
          return (
            <button key={f.id} onClick={() => setOchiq(f)} style={{
              textAlign: 'left', cursor: 'pointer', borderRadius: '8px', padding: '8px 10px',
              border: `1px solid ${ogoh ? '#f0a0a0' : '#e3e8ef'}`,
              background: ogoh ? '#fff5f5' : '#f7f9fc', fontSize: '12px', color: '#333'
            }}>
              <b>{tr("{raqam}-surat", { raqam: i + 1 })}</b>
              <div style={{ color: '#666', marginTop: '3px' }}>
                {f.olingan_vaqt ? new Date(f.olingan_vaqt).toLocaleTimeString() : tr("vaqtsiz")}
                {f.latitude == null && ` · ${tr("GPSsiz")}`}
                {f.soxta_gps && ` · ${tr("SOXTA GPS")}`}
                {f.masofa_m != null && f.masofa_m > 500 && ` · ${tr("{masofa} m narida", { masofa: f.masofa_m })}`}
                {f.masofa_m === null && f.latitude != null && ` · ${tr("tayanch nuqta")}`}
              </div>
            </button>
          );
        })}
      </div>
      {ochiq && <SuratOyna foto={ochiq} token={token} yop={() => setOchiq(null)} />}
    </div>
  );
}

const inputStyle = {
  padding: '9px 11px', border: '1px solid #ddd', borderRadius: '8px',
  fontSize: '14px', width: '100%', boxSizing: 'border-box',
};
const btn = {
  padding: '10px 18px', background: '#4f8ef7', color: '#fff', border: 'none',
  borderRadius: '8px', fontSize: '14px', cursor: 'pointer',
};
const smallBtn = {
  padding: '6px 12px', background: '#eef1f7', color: '#1a1a2e',
  border: '1px solid #ddd', borderRadius: '8px', fontSize: '12px',
  cursor: 'pointer',
};
const card = {
  background: '#fff', borderRadius: '12px', padding: '20px',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)', marginBottom: '20px',
};
const label = { fontSize: '12px', color: '#666', display: 'block', marginBottom: '5px' };

const nishon = (rang) => ({
  padding: '3px 9px', borderRadius: '6px', fontSize: '11px',
  fontWeight: 600, background: `${rang}22`, color: rang,
  display: 'inline-block',
});

const HOLAT_RANGI = {
  rejalashtirilgan: '#c9a227',
  otkazildi: '#2a9d5c',
  bekor: '#999',
};
const HOLAT_NOMI = {
  rejalashtirilgan: tr("Rejalashtirilgan"),
  otkazildi: tr("O'tkazildi"),
  bekor: tr("Bekor qilingan"),
};

const BOSH = {
  nomi: '', joyi: '', sana: '', vaqt: '10:00', maqsad: '',
  sudya: '', prokuror: '', kotib: '', inspektor_id: '', hujjat_raqami: '',
};

const Maydon = ({ nom, children }) => (
  <div><label style={label}>{nom}</label>{children}</div>
);

const sanaMatni = (s) => (s ? String(s).slice(0, 10).split('-').reverse().join('.') : '—');
const vaqtMatni = (v) => (v ? String(v).slice(0, 5) : '');

function SayyorSud() {
  const [bolim, setBolim] = useState('reja');
  const [sudlar, setSudlar] = useState([]);
  const [mahkumlar, setMahkumlar] = useState([]);
  const [xodimlar, setXodimlar] = useState([]);
  const [forma, setForma] = useState({ ...BOSH });
  const [ochilgan, setOchilgan] = useState(null);
  const [xato, setXato] = useState('');
  const [xabar, setXabar] = useState('');
  const [saqlanmoqda, setSaqlanmoqda] = useState(false);

  const token = localStorage.getItem('token');
  const sarlavha = { headers: { authorization: token } };

  const yukla = useCallback(() => {
    axios.get(`${API}/probatsiya/sayyor-sudlar`, { headers: { authorization: token } })
      .then((r) => setSudlar(r.data))
      .catch((e) => setXato(e.response?.data?.error || tr("Ro'yxatni olishda xato")));

    // DIQQAT: bu endpoint massiv EMAS, {tuman, mahkumlar} obyekti
    // qaytaradi (controllers/probatsiyaController.js -> getMahkumlar).
    // To'g'ridan-to'g'ri `r.data` ni qo'ysak, quyidagi `.filter` yiqiladi.
    axios.get(`${API}/probatsiya/mahkumlar`, { headers: { authorization: token } })
      .then((r) => setMahkumlar(Array.isArray(r.data?.mahkumlar) ? r.data.mahkumlar : []))
      .catch(() => { /* ro'yxat bo'sh qolaveradi */ });

    // Inspektor tanlash uchun — faqat o'z tumanidagi xodimlar.
    // Butun tizim xodimlari (`/users/all`) admin uchun va bu yerga
    // kerak ham emas.
    axios.get(`${API}/probatsiya/xodimlar`, { headers: { authorization: token } })
      .then((r) => setXodimlar(Array.isArray(r.data) ? r.data : []))
      .catch(() => setXodimlar([]));
  }, [token]);

  useEffect(() => { yukla(); }, [yukla]);

  const ozgart = (k, v) => setForma((f) => ({ ...f, [k]: v }));

  const yarat = async () => {
    setXato(''); setXabar(''); setSaqlanmoqda(true);
    try {
      const r = await axios.post(`${API}/probatsiya/sayyor-sudlar`, forma, sarlavha);
      setXabar(tr("Sayyor sud belgilandi — {sanaMatni}", { sanaMatni: sanaMatni(r.data.sud.sana) }));
      setForma({ ...BOSH });
      yukla();
      setBolim('royxat');
    } catch (e) {
      setXato(e.response?.data?.error || tr("Saqlashda xato"));
    } finally {
      setSaqlanmoqda(false);
    }
  };

  const ochish = async (id) => {
    setXato('');
    try {
      const r = await axios.get(`${API}/probatsiya/sayyor-sudlar/${id}`, sarlavha);
      setOchilgan(r.data);
    } catch (e) {
      setXato(e.response?.data?.error || tr("Ochishda xato"));
    }
  };

  const mahkumQosh = async (mahkumId) => {
    if (!mahkumId) return;
    try {
      const r = await axios.post(
        `${API}/probatsiya/sayyor-sudlar/${ochilgan.id}/mahkumlar`,
        { mahkum_id: mahkumId }, sarlavha
      );
      setOchilgan((o) => ({ ...o, mahkumlar: r.data.mahkumlar }));
      yukla();
    } catch (e) {
      setXato(e.response?.data?.error || tr("Qo'shishda xato"));
    }
  };

  const mahkumOchir = async (mahkumId) => {
    try {
      const r = await axios.delete(
        `${API}/probatsiya/sayyor-sudlar/${ochilgan.id}/mahkumlar/${mahkumId}`, sarlavha
      );
      setOchilgan((o) => ({ ...o, mahkumlar: r.data.mahkumlar }));
      yukla();
    } catch (e) {
      setXato(e.response?.data?.error || tr("Xato"));
    }
  };

  const qarorYoz = async (mahkumId, qaror) => {
    try {
      const r = await axios.put(
        `${API}/probatsiya/sayyor-sudlar/${ochilgan.id}/mahkumlar/${mahkumId}`,
        { qaror }, sarlavha
      );
      setOchilgan((o) => ({ ...o, mahkumlar: r.data.mahkumlar }));
    } catch (e) {
      setXato(e.response?.data?.error || tr("Xato"));
    }
  };

  const bekorQil = async (sud) => {
    if (!window.confirm(
      tr("\"{nomi}\" bekor qilinsinmi?\n\n", { nomi: sud.nomi })
      + tr("Yozuv o'chirilmaydi — holati \"bekor qilingan\" bo'ladi.")
    )) return;
    try {
      await axios.delete(`${API}/probatsiya/sayyor-sudlar/${sud.id}`, sarlavha);
      setXabar(tr("Bekor qilindi"));
      setOchilgan(null);
      yukla();
    } catch (e) {
      setXato(e.response?.data?.error || tr("Xato"));
    }
  };

  // Sudda hali qatnashmagan mahkumlar
  const qolganMahkumlar = ochilgan
    ? mahkumlar.filter((m) => !ochilgan.mahkumlar?.some((x) => x.mahkum_id === m.id))
    : [];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ fontSize: '22px', margin: 0 }}>⚖️ {tr("Sayyor sud")}</h2>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
          {[['reja', tr("📋 Rejalash")], ['royxat', tr("📅 Ro'yxat")]].map(([k, n]) => (
            <button
              key={k}
              onClick={() => { setBolim(k); setOchilgan(null); }}
              style={{
                ...smallBtn,
                padding: '9px 16px',
                background: bolim === k ? '#4f8ef7' : '#eef1f7',
                color: bolim === k ? '#fff' : '#1a1a2e',
                border: bolim === k ? '1px solid #4f8ef7' : '1px solid #ddd',
              }}
            >{n}</button>
          ))}
        </div>
      </div>

      {xato && <p style={{ color: '#d33', fontSize: '13px', marginBottom: '12px' }}>{xato}</p>}
      {xabar && <p style={{ color: '#2a7', fontSize: '13px', marginBottom: '12px' }}>{xabar}</p>}

      {/* ---------------- REJALASH ---------------- */}
      {bolim === 'reja' && (
        <div style={card}>
          <h3 style={{ fontSize: '15px', marginTop: 0, marginBottom: '16px' }}>
            {tr("Yangi sayyor sud")}
          </h3>

          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '10px', marginBottom: '16px' }}>
            <Maydon nom={tr("Sud nomi / mavzu *")}>
              <input style={inputStyle} placeholder={tr("Probatsiya nazorati yig'ilishi")}
                value={forma.nomi} onChange={(e) => ozgart('nomi', e.target.value)} />
            </Maydon>
            <Maydon nom={tr("Sana *")}>
              <input type="date" style={inputStyle} value={forma.sana}
                onChange={(e) => ozgart('sana', e.target.value)} />
            </Maydon>
            <Maydon nom={tr("Vaqt")}>
              <input type="time" style={inputStyle} value={forma.vaqt}
                onChange={(e) => ozgart('vaqt', e.target.value)} />
            </Maydon>
            <Maydon nom={tr("Hujjat raqami")}>
              <input style={inputStyle} placeholder="56/30-147"
                value={forma.hujjat_raqami}
                onChange={(e) => ozgart('hujjat_raqami', e.target.value)} />
            </Maydon>
            <div style={{ gridColumn: 'span 2' }}>
              <Maydon nom={tr("Bino / joy")}>
                <input style={inputStyle} placeholder={tr("Tuman hokimligi, majlis zali")}
                  value={forma.joyi} onChange={(e) => ozgart('joyi', e.target.value)} />
              </Maydon>
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <Maydon nom={tr("Probatsiya inspektori (telefonda shu sudni u ko'radi)")}>
                {xodimlar.length > 0 ? (
                  <select style={inputStyle} value={forma.inspektor_id}
                    onChange={(e) => ozgart('inspektor_id', e.target.value)}>
                    <option value="">— {tr("tanlang —")}</option>
                    {xodimlar.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.full_name} {u.badge_number ? `(${u.badge_number})` : ''}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input style={inputStyle} placeholder={tr("Xodim ID raqami")}
                    value={forma.inspektor_id}
                    onChange={(e) => ozgart('inspektor_id', e.target.value.replace(/\D/g, ''))} />
                )}
              </Maydon>
            </div>
          </div>

          <p style={{ fontSize: '12px', color: '#888', margin: '0 0 8px' }}>
            {tr("Rasmiy ishtirokchilar")}
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
            <Maydon nom={tr("Sudya")}>
              <input style={inputStyle} value={forma.sudya}
                onChange={(e) => ozgart('sudya', e.target.value)} />
            </Maydon>
            <Maydon nom={tr("Prokuror")}>
              <input style={inputStyle} value={forma.prokuror}
                onChange={(e) => ozgart('prokuror', e.target.value)} />
            </Maydon>
            <Maydon nom={tr("Kotib")}>
              <input style={inputStyle} value={forma.kotib}
                onChange={(e) => ozgart('kotib', e.target.value)} />
            </Maydon>
          </div>

          <Maydon nom={tr("Sud maqsadi")}>
            <textarea style={{ ...inputStyle, height: '60px', resize: 'vertical' }}
              placeholder={tr("Mahkumlarning probatsiya muddati va xulq-atvorini muhokama qilish")}
              value={forma.maqsad} onChange={(e) => ozgart('maqsad', e.target.value)} />
          </Maydon>

          <p style={{ fontSize: '12px', color: '#888', margin: '14px 0 0' }}>
            {tr("Mahkumlar sud belgilangandan keyin, «Ro'yxat» bo'limida qo'shiladi.")}
          </p>

          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <button style={btn} onClick={yarat} disabled={saqlanmoqda}>
              {saqlanmoqda ? tr("Saqlanmoqda…") : tr("📅 Sud belgilash")}
            </button>
            <button style={smallBtn} onClick={() => setForma({ ...BOSH })}>
              {tr("Tozalash")}
            </button>
          </div>
        </div>
      )}

      {/* ---------------- RO'YXAT ---------------- */}
      {bolim === 'royxat' && !ochilgan && (
        <div style={card}>
          {sudlar.length === 0 ? (
            <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', padding: '24px' }}>
              {tr("Hali sayyor sud belgilanmagan")}
            </p>
          ) : sudlar.map((s) => (
            <div key={s.id}
              onClick={() => ochish(s.id)}
              style={{
                border: '1px solid #eee', borderRadius: '10px', padding: '14px',
                marginBottom: '10px', cursor: 'pointer', display: 'flex',
                alignItems: 'center', gap: '14px',
              }}>
              <div style={{
                background: '#f5f7fb', borderRadius: '8px', padding: '8px 12px',
                textAlign: 'center', minWidth: '58px',
              }}>
                <div style={{ fontSize: '18px', fontWeight: 800, color: '#4f8ef7' }}>
                  {String(s.sana).slice(8, 10)}
                </div>
                <div style={{ fontSize: '10px', color: '#888' }}>
                  {tr("{slice}-oy", { slice: String(s.sana).slice(5, 7) })}
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '14px', fontWeight: 600 }}>{s.nomi}</div>
                <div style={{ fontSize: '12px', color: '#888', marginTop: '3px' }}>
                  {s.joyi || tr("joy ko'rsatilmagan")}
                  {s.vaqt ? ` · ${vaqtMatni(s.vaqt)}` : ''}
                </div>
                <div style={{ display: 'flex', gap: '6px', marginTop: '7px', flexWrap: 'wrap' }}>
                  {s.inspektor_nomi && <span style={nishon('#7a5af0')}>👮 {s.inspektor_nomi}</span>}
                  <span style={nishon('#e0554f')}>👥 {tr("{mahkumlar_soni} mahkum", { mahkumlar_soni: s.mahkumlar_soni })}</span>
                  {s.holati === 'otkazildi' && s.foto_soni > 0 && (
                    <span style={nishon('#2a9d5c')}>📸 {tr("{foto_soni} foto", { foto_soni: s.foto_soni })}</span>
                  )}
                  {s.holati === 'otkazildi' && s.gps_lat != null && (
                    <span style={nishon('#2a9d5c')}>📡 {tr("GPS tasdiqlangan")}</span>
                  )}
                </div>
              </div>
              <span style={nishon(HOLAT_RANGI[s.holati] || '#999')}>
                {HOLAT_NOMI[s.holati] || s.holati}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* ---------------- BITTA SUD ---------------- */}
      {ochilgan && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
            <div>
              <h3 style={{ fontSize: '17px', margin: 0 }}>{ochilgan.nomi}</h3>
              <p style={{ fontSize: '13px', color: '#888', margin: '5px 0 0' }}>
                {sanaMatni(ochilgan.sana)}
                {ochilgan.vaqt ? ` · ${vaqtMatni(ochilgan.vaqt)}` : ''}
                {ochilgan.joyi ? ` · ${ochilgan.joyi}` : ''}
              </p>
            </div>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center' }}>
              <span style={nishon(HOLAT_RANGI[ochilgan.holati] || '#999')}>
                {HOLAT_NOMI[ochilgan.holati] || ochilgan.holati}
              </span>
              {ochilgan.holati === 'rejalashtirilgan' && (
                <button style={{ ...smallBtn, color: '#c00' }}
                  onClick={() => bekorQil(ochilgan)}>{tr("Bekor qilish")}</button>
              )}
              <button style={smallBtn} onClick={() => setOchilgan(null)}>← {tr("Orqaga")}</button>
            </div>
          </div>

          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px',
            fontSize: '13px', marginBottom: '18px',
          }}>
            {[
              [tr("Sudya"), ochilgan.sudya],
              [tr("Prokuror"), ochilgan.prokuror],
              [tr("Inspektor"), ochilgan.inspektor_nomi],
              [tr("Kotib"), ochilgan.kotib],
            ].map(([n, v]) => (
              <div key={n}>
                <div style={{ color: '#999', fontSize: '11px' }}>{n}</div>
                <div>{v || '—'}</div>
              </div>
            ))}
          </div>

          {ochilgan.holati === 'otkazildi' && (
            <div style={{
              background: '#f2f9f4', border: '1px solid #cfe8d8',
              borderRadius: '10px', padding: '12px', marginBottom: '18px',
              fontSize: '13px',
            }}>
              <b>{tr("Yakunlangan.")}</b>{tr("{foto_soni} ta fotosurat olingan", { foto_soni: ochilgan.foto_soni })}
              {ochilgan.gps_lat != null
                ? tr(" · GPS: {toFixed}, {toFixed2}", { toFixed: Number(ochilgan.gps_lat).toFixed(4), toFixed2: Number(ochilgan.gps_lon).toFixed(4) })
                  + (ochilgan.gps_aniqlik_m ? ` (±${Math.round(ochilgan.gps_aniqlik_m)} m)` : '')
                : tr(" · GPS qayd etilmagan")}
              {ochilgan.xulosa && (
                <div style={{ marginTop: '8px', color: '#333' }}>{ochilgan.xulosa}</div>
              )}
              <div style={{ marginTop: '8px', color: '#777', fontSize: '12px' }}>
                {tr("Suratlar serverda saqlanadi: har biri olingan vaqti va joylashuvi bilan. To'liq nusxasi inspektor telefonidagi ma'lumotnomada ham bor.")}
              </div>
            </div>
          )}

          <Suratlar fotolar={ochilgan.fotolar} token={token} />

          <p style={{ fontSize: '12px', color: '#888', margin: '0 0 8px' }}>
            {tr("Ko'rib chiqiladigan mahkumlar")}
          </p>

          {ochilgan.holati === 'rejalashtirilgan' && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
              <select
                style={{ ...inputStyle, maxWidth: '420px' }}
                value=""
                onChange={(e) => mahkumQosh(e.target.value)}
              >
                <option value="">— {tr("mahkum qo'shish —")}</option>
                {qolganMahkumlar.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.familiya} {m.ism} {m.jk_moddasi ? `— ${m.jk_moddasi}` : ''}
                  </option>
                ))}
              </select>
              {qolganMahkumlar.length === 0 && mahkumlar.length === 0 && (
                <span style={{ fontSize: '12px', color: '#c60', alignSelf: 'center' }}>
                  {tr("Avval «Mahkumlar» bo'limiga yozuv qo'shing")}
                </span>
              )}
            </div>
          )}

          {(!ochilgan.mahkumlar || ochilgan.mahkumlar.length === 0) ? (
            <p style={{ color: '#999', fontSize: '13px', padding: '12px 0' }}>
              {tr("Ro'yxat bo'sh")}
            </p>
          ) : ochilgan.mahkumlar.map((m, i) => (
            <div key={m.id} style={{
              border: '1px solid #eee', borderRadius: '9px', padding: '11px',
              marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px',
            }}>
              <span style={{ color: '#aaa', fontSize: '13px' }}>{i + 1}.</span>
              <div style={{ minWidth: '210px' }}>
                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                  {m.familiya} {m.ism} {m.sharif || ''}
                </div>
                <div style={{ fontSize: '11px', color: '#888' }}>
                  {m.jk_moddasi || '—'}{m.jazo_turi ? ` · ${m.jazo_turi}` : ''}
                </div>
              </div>
              <input
                style={{ ...inputStyle, flex: 1 }}
                placeholder={tr("Sud qarori")}
                defaultValue={m.qaror || ''}
                onBlur={(e) => {
                  if (e.target.value !== (m.qaror || '')) qarorYoz(m.mahkum_id, e.target.value);
                }}
              />
              {ochilgan.holati === 'rejalashtirilgan' && (
                <button style={{ ...smallBtn, color: '#c00' }}
                  onClick={() => mahkumOchir(m.mahkum_id)}>✕</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SayyorSud;
